// import DOMPurify from "dompurify";
// import { useRef, useEffect, useState } from "react";
// import Hls from "hls.js";
// import CommonTemplateRenderer from "./CommonTemplateRenderer";
// import MCQPlayer from "./MCQPlayer";

// const SmartPlayer = ({
//   content,
//   onNext,
//   onQuizComplete,
//   quizProgress = {},
// }) => {
//   const mediaRef = useRef(null);

//   // add 11/05/26
//   const [resolvedUrl, setResolvedUrl] = useState(null);
// const [resolvedType, setResolvedType] = useState(null);

// // =========================================================
// // XML RESOLVER
// // =========================================================

// useEffect(() => {
//   const resolveXml = async () => {
//     try {
//       const xmlUrl = content?.playUrl || content?.url;

//       if (!xmlUrl || !xmlUrl.toLowerCase().endsWith(".xml")) return;

//       const res = await fetch(xmlUrl);
//       const xmlText = await res.text();

//       const parser = new DOMParser();
//       const xml = parser.parseFromString(xmlText, "text/xml");

//       // try multiple tags
//       const actualUrl =
//         xml.querySelector("file")?.textContent ||
//         xml.querySelector("src")?.textContent ||
//         xml.querySelector("content")?.getAttribute("src");

//       if (actualUrl) {
//         setResolvedUrl(actualUrl);

//         if (actualUrl.includes(".mp4")) {
//           setResolvedType("video");
//         } else if (actualUrl.includes(".pdf")) {
//           setResolvedType("pdf");
//         } else if (actualUrl.includes(".html")) {
//           setResolvedType("html");
//         } else if (
//           actualUrl.includes(".jpg") ||
//           actualUrl.includes(".png") ||
//           actualUrl.includes(".jpeg")
//         ) {
//           setResolvedType("image");
//         }
//       }
//     } catch (err) {
//       console.error("XML Parse Error:", err);
//     }
//   };

//   resolveXml();
// }, [content]);

// //

//   // VIDEO / AUDIO SUPPORT
//   useEffect(() => {
//     if (!content) return;
//     if (content.type !== "video" && content.type !== "audio") return;
//     //

//     const media = mediaRef.current;
//     if (!media || !content.url) return;

//     const url = content.url.toLowerCase();
//     let hls;

//     if (url.includes(".m3u8")) {
//       if (Hls.isSupported()) {
//         hls = new Hls();
//         hls.loadSource(content.url);
//         hls.attachMedia(media);
//       } else {
//         media.src = content.url;
//       }
//     } else {
//       media.src = content.url;
//     }

//     return () => {
//       if (hls) hls.destroy();
//     };
//   }, [content]);

//   // =========================================================
//   // EMPTY CONTENT
//   // =========================================================
//   if (!content) {
//     return (
//       <div className="h-full flex items-center justify-center text-slate-400 text-2xl">
//         No Content
//       </div>
//     );
//   }

//   // =========================================================
//   // COMMON TEMPLATE TYPES
//   // =========================================================
//   const templateTypes = ["ti", "ts", "afl", "rap", "cm", "wks"];

//   if (
//     templateTypes.includes(content.type) &&
//     content.url?.toLowerCase().endsWith(".xml")
//   ) {
//     return <CommonTemplateRenderer type={content.type} url={content.url} />;
//   }

//   // =========================================================
//   // VIDEO + AUDIO
//   // =========================================================
//   if (
//     content.type === "video" ||
//     content.type === "audio" ||
//     content.url.toLowerCase()?.includes(".m3u8")
//   ) {
//     return (
//       <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
//       <video
//         ref={mediaRef}
//         controls
//         autoPlay
//         style={{
//           width: "100%",
//           height: "100%",
//           objectFit: "contain",
//           background: "black",
//         }}
//       />
//       </div>
//     );
//   }

//   if (content.type === "ppt") {
//     const isLocal = content.url.includes("localhost");

//     if (isLocal) {
//       return (
//         <div className="h-full flex flex-col items-center justify-center gap-4 text-white">
//           <h2 className="text-2xl font-semibold">
//             PowerPoint Preview Not Available on Localhost
//           </h2>

//           <a
//             href={content.url}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="px-5 py-3 rounded-lg bg-indigo-600 hover:bg-indigo-700"
//           >
//             Open / Download PPT
//           </a>
//         </div>
//       );
//     }

//     const officeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
//       content.url,
//     )}`;

//     return (
//       <iframe
//         src={officeUrl}
//         style={{ width: "100%", height: "100%", border: "none" }}
//         title="PowerPoint"
//       />
//     );
//   }

//   // =========================================================
//   // PDF
//   // =========================================================
//   if (content.type === "pdf" || content.url?.toLowerCase().endsWith(".pdf")) {
//     return (
//       <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
//       <iframe
//         src={content.url}
//         style={{
//           width: "100%",
//           height: "100%",
//           border: "none",
//         }}
//         title="PDF"
//       />
//       </div>
//     );
//   }

//   // =========================================================
//   // DOC
//   // =========================================================
//   if (content.type === "doc" || content.url?.toLowerCase().endsWith(".doc")) {
//     const isLocal = content.url.includes("localhost");

//     // ✅ Localhost fallback
//     if (isLocal) {
//       return (
//         <div className="h-full flex flex-col items-center justify-center gap-4 text-white">
//           <h2 className="text-2xl font-semibold">
//             DOC Preview Not Available on Localhost
//           </h2>
//           <p>This Word file will open as a download.</p>

//           <a
//             href={content.url}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="px-5 py-3 rounded-lg bg-indigo-600 hover:bg-indigo-700"
//           >
//             Open / Download DOC File
//           </a>
//         </div>
//       );
//     }

//     // ✅ Production preview
//     const officeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
//       content.url,
//     )}`;

//     return (
//       <iframe
//         key={content.id}
//         src={officeUrl}
//         style={{
//           width: "100%",
//           height: "100%",
//           border: "none",
//         }}
//         title="Word Document"
//       />
//     );
//   }
//   // =========================================================
//   // IMAGE
//   // =========================================================
//   if (content.type === "image") {
//     return (
//       <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
//         <img
//           src={content.url}
//           alt="Content"
//           style={{
//             maxWidth: "100%",
//             maxHeight: "100%",
//             objectFit: "contain",
//           }}
//         />
//       </div>
//     );
//   }

//   // =========================================================
//   // HTML
//   // =========================================================
//   if (content.type === "html" || content.url?.toLowerCase().endsWith(".html")) {
//     // Raw HTML string
//     if (content.html) {
//       return (
//         <iframe
//           key={content.id}
//           srcDoc={DOMPurify.sanitize(content.html)}
//           sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
//           style={{
//             width: "100%",
//             height: "100%",
//             border: "none",
//           }}
//           title="HTML Content"
//         />
//       );
//     }

//     // Remote URL / local file
//     if (content.url || content.filePath) {
//       return (
//         <iframe
//           key={content.id}
//           src={content.url || content.filePath}
//           style={{
//             width: "100%",
//             height: "100%",
//             border: "none",
//           }}
//           title="HTML Content"
//         />
//       );
//     }
//   }

//   // =========================================================
//   // MCQ
//   // =========================================================
//   if (content.type === "mcq") {
//     return (
//       <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
//       <MCQPlayer
//         content={content}
//         onNext={onNext}
//         onQuizComplete={onQuizComplete}
//         quizProgress={quizProgress}
//       />
//       </div>
//     );
//   }

//   // =========================================================
//   // FALLBACK
//   // =========================================================
//   return (
//     <div className="h-full flex items-center justify-center text-slate-400 text-2xl">
//       Unsupported Content Type: {content.type}
//     </div>
//   );
// };

// export default SmartPlayer;


import DOMPurify from "dompurify/dist/purify.min.js";
import { useRef, useEffect, useState } from "react";
import Hls from "hls.js";
import CommonTemplateRenderer from "./CommonTemplateRenderer";
import MCQPlayer from "./MCQPlayer";

const SmartPlayer = ({
  content,
  onNext,
  onQuizComplete,
  quizProgress = {},
}) => {
  const mediaRef = useRef(null);

  const [resolvedUrl, setResolvedUrl] = useState(null);
  const [resolvedType, setResolvedType] = useState(null);

  const [screenFiles, setScreenFiles] = useState([]);
  const [currentScreenIndex, setCurrentScreenIndex] = useState(0);

  // =========================================================
  // DETECT CONTENT TYPE
  // =========================================================

  const detectType = (url) => {
    if (!url) return;

    const lower = url.toLowerCase();

    if (
      lower.endsWith(".mp4") ||
      lower.endsWith(".m3u8") ||
      lower.endsWith(".mp3")
    ) {
      setResolvedType("video");
    } else if (lower.endsWith(".pdf")) {
      setResolvedType("pdf");
    } else if (
      lower.endsWith(".html") ||
      lower.endsWith(".htm")
    ) {
      setResolvedType("html");
    } else if (
      lower.endsWith(".jpg") ||
      lower.endsWith(".jpeg") ||
      lower.endsWith(".png") ||
      lower.endsWith(".gif")
    ) {
      setResolvedType("image");
    } else if (
      lower.endsWith(".doc") ||
      lower.endsWith(".docx")
    ) {
      setResolvedType("doc");
    } else if (
      lower.endsWith(".ppt") ||
      lower.endsWith(".pptx")
    ) {
      setResolvedType("ppt");
    } else {
      setResolvedType(content?.mediatype || content?.type);
    }
  };

  // =========================================================
  // XML RESOLVER
  // =========================================================

  useEffect(() => {
    const resolveXml = async () => {
      try {
        const xmlUrl = content?.playUrl || content?.url;

        if (!xmlUrl) return;

        // NON XML DIRECT FILE
        if (!xmlUrl.toLowerCase().endsWith(".xml")) {
          setResolvedUrl(xmlUrl);

          detectType(xmlUrl);

          return;
        }

        // FETCH XML
        const response = await fetch(xmlUrl);

        const xmlText = await response.text();

        const parser = new DOMParser();

        const xmlDoc = parser.parseFromString(
          xmlText,
          "text/xml"
        );

        // GET ALL ScreenFile TAGS
        const screenNodes =
          xmlDoc.getElementsByTagName("ScreenFile");

        if (!screenNodes.length) {
          console.log("No ScreenFile found in XML");
          return;
        }

        // CONVERT NODELIST TO ARRAY
        const files = Array.from(screenNodes).map((node) =>
          node.textContent.trim()
        );

        setScreenFiles(files);

        // BASE URL
        const baseUrl = xmlUrl.substring(
          0,
          xmlUrl.lastIndexOf("/") + 1
        );

        // FIRST SCREEN
        const firstFile = files[0];

        const finalUrl = baseUrl + firstFile;

        setResolvedUrl(finalUrl);

        detectType(finalUrl);
      } catch (error) {
        console.error("XML Parse Error:", error);
      }
    };

    resolveXml();
  }, [content]);

  // =========================================================
  // SCREEN CHANGE
  // =========================================================

  useEffect(() => {
    if (!screenFiles.length) return;

    const xmlUrl = content?.playUrl || content?.url;

    const baseUrl = xmlUrl.substring(
      0,
      xmlUrl.lastIndexOf("/") + 1
    );

    const file = screenFiles[currentScreenIndex];

    if (!file) return;

    const finalUrl = baseUrl + file;

    setResolvedUrl(finalUrl);

    detectType(finalUrl);
  }, [currentScreenIndex]);

  // =========================================================
  // FINAL CONTENT
  // =========================================================

  // const finalContent = {
  //   ...content,
  //   url: resolvedUrl || content?.playUrl || content?.url,
  //   type:
  //     resolvedType ||
  //     content?.mediatype ||
  //     content?.type,
  // };
// =========================================================
// MCQ TRANSFORM
// =========================================================

let transformedQuestions = [];

if (
  (content?.type === "mcq" ||
    resolvedType === "mcq") &&
  content?.questions &&
  content?.answers
) {
  transformedQuestions = content.questions.map((q) => {
    const questionAnswers = content.answers
      .filter((a) => a.qid === q.qid)
      .sort((a, b) => a.ansno - b.ansno);

    return {
      qid: q.qid,
      qno: q.qsno,
      question: q.qtext,

      options: questionAnswers.map((a) => ({
        text: a.anstext,
        isCorrect: a.iscorrect,
        ansno: a.ansno,
      })),
    };
  });
}

// =========================================================
// FINAL CONTENT
// =========================================================

const finalContent = {
  ...content,
  questions:
    transformedQuestions.length > 0
      ? transformedQuestions
      : content?.questions || [],

  url: resolvedUrl || content?.playUrl || content?.url,

  type:
    resolvedType ||
    content?.mediatype ||
    content?.type,
};
  // =========================================================
  // VIDEO SUPPORT
  // =========================================================

  useEffect(() => {
    if (!finalContent?.url) return;

    if (
      finalContent.type !== "video" &&
      finalContent.type !== "audio"
    ) {
      return;
    }

    const media = mediaRef.current;

    if (!media) return;

    const url = finalContent.url.toLowerCase();

    let hls;

    if (url.includes(".m3u8")) {
      if (Hls.isSupported()) {
        hls = new Hls();

        hls.loadSource(finalContent.url);

        hls.attachMedia(media);
      } else {
        media.src = finalContent.url;
      }
    } else {
      media.src = finalContent.url;
    }

    return () => {
      if (hls) hls.destroy();
    };
  }, [finalContent]);

  // =========================================================
  // EMPTY CONTENT
  // =========================================================

  if (!content) {
    return (
      <div className="h-full min-h-[240px] flex items-center justify-center text-white px-4 text-center">
        No Content
      </div>
    );
  }

  // =========================================================
  // COMMON TEMPLATE TYPES
  // =========================================================

  const templateTypes = ["ti", "ts", "afl", "rap", "cm", "wks"];

  if (
    templateTypes.includes(finalContent.type) &&
    finalContent.url?.toLowerCase().endsWith(".xml")
  ) {
    return (
      <CommonTemplateRenderer
        type={finalContent.type}
        url={finalContent.url}
      />
    );
  }

  // =========================================================
  // VIDEO / AUDIO
  // =========================================================

  // if (
  //   finalContent.type === "video" ||
  //   finalContent.type === "audio"
  // ) {
  //   return (
  //     <div
  //       style={{
  //         width: "100%",
  //         height: "100%",
  //         background: "black",
  //       }}
  //     >
  //       <video
  //         ref={mediaRef}
  //         controls
  //         autoPlay
  //         style={{
  //           width: "100%",
  //           height: "90%",
  //           objectFit: "contain",
  //           background: "black",
  //         }}
  //       />

  //       {/* MULTIPLE SCREEN NAVIGATION */}

  //       {screenFiles.length > 1 && (
  //         <div className="flex items-center justify-center gap-4 p-4 bg-gray-900">
  //           <button
  //             disabled={currentScreenIndex === 0}
  //             onClick={() =>
  //               setCurrentScreenIndex((prev) => prev - 1)
  //             }
  //             className="px-4 py-2 bg-blue-600 rounded text-white disabled:opacity-50"
  //           >
  //             Previous
  //           </button>

  //           <div className="text-white">
  //             {currentScreenIndex + 1} / {screenFiles.length}
  //           </div>

  //           <button
  //             disabled={
  //               currentScreenIndex ===
  //               screenFiles.length - 1
  //             }
  //             onClick={() =>
  //               setCurrentScreenIndex((prev) => prev + 1)
  //             }
  //             className="px-4 py-2 bg-blue-600 rounded text-white disabled:opacity-50"
  //           >
  //             Next
  //           </button>
  //         </div>
  //       )}
  //     </div>
  //   );
  // }
  if (
  finalContent.type === "video" ||
  finalContent.type === "audio"
) {
  return (
    <div className="w-full h-full min-h-0 bg-black flex flex-col">
      
      {/* PLAYER */}
      <div className="flex-1 flex items-center justify-center overflow-hidden p-2 sm:p-4">
        <video
          ref={mediaRef}
          controls
          autoPlay
          className="w-full h-full object-contain bg-black"
        />
      </div>

      {/* MULTIPLE SCREEN NAVIGATION */}
      {screenFiles.length > 1 && (
        <div className="flex items-center justify-center gap-3 p-3 bg-gray-900 flex-wrap">
          <button
            disabled={currentScreenIndex === 0}
            onClick={() =>
              setCurrentScreenIndex((prev) => prev - 1)
            }
            className="px-4 py-2 bg-blue-600 rounded text-white disabled:opacity-50 min-w-[92px]"
          >
            Previous
          </button>

          <div className="text-white text-sm sm:text-base">
            {currentScreenIndex + 1} / {screenFiles.length}
          </div>

          <button
            disabled={
              currentScreenIndex ===
              screenFiles.length - 1
            }
            onClick={() =>
              setCurrentScreenIndex((prev) => prev + 1)
            }
            className="px-4 py-2 bg-blue-600 rounded text-white disabled:opacity-50 min-w-[92px]"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

  // =========================================================
  // PDF
  // =========================================================

  if (finalContent.type === "pdf") {
    return (
      <iframe
        src={finalContent.url}
        title="PDF"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    );
  }

  // =========================================================
  // IMAGE
  // =========================================================

  // if (finalContent.type === "image") {
  //   return (
  //     <div
  //       style={{
  //         width: "100%",
  //         height: "100%",
  //         overflow: "hidden",
  //       }}
  //     >
  //       <img
  //         src={finalContent.url}
  //         alt="content"
  //         style={{
  //           width: "100%",
  //           height: "100%",
  //           objectFit: "contain",
  //         }}
  //       />
  //     </div>
  //   );
  // }

  if (finalContent.type === "image") {
  return (
    <div className="w-full h-full flex items-center justify-center bg-black overflow-hidden p-2 sm:p-4">
      <img
        src={finalContent.url}
        alt="content"
        className="max-w-full max-h-full object-contain"
      />
    </div>
  );
}

  // =========================================================
  // DOC
  // =========================================================

  if (finalContent.type === "doc") {
    const officeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
      finalContent.url
    )}`;

    return (
      <iframe
        src={officeUrl}
        title="DOC"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    );
  }

  // =========================================================
  // PPT
  // =========================================================

  if (finalContent.type === "ppt") {
    const officeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
      finalContent.url
    )}`;

    return (
      <iframe
        src={officeUrl}
        title="PPT"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    );
  }

  // =========================================================
  // HTML
  // =========================================================

  if (finalContent.type === "html") {
    if (finalContent.html) {
      return (
        <iframe
          srcDoc={DOMPurify.sanitize(finalContent.html)}
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
          title="HTML"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      );
    }

    return (
      <iframe
        src={finalContent.url}
        title="HTML"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    );
  }

  // =========================================================
  // MCQ
  // =========================================================

  // if (finalContent.type === "mcq") {
  //   return (
  //     <MCQPlayer
  //       content={finalContent}
  //       onNext={onNext}
  //       onQuizComplete={onQuizComplete}
  //       quizProgress={quizProgress}
  //     />
  //   );
  // }

  if (finalContent.type === "mcq") {
  return (
    <div className="w-full h-full min-h-0 overflow-y-auto bg-gray-950">
      <MCQPlayer
        content={finalContent}
        onNext={onNext}
        onQuizComplete={onQuizComplete}
        quizProgress={quizProgress}
      />
    </div>
  );
}

  // =========================================================
  // FALLBACK
  // =========================================================

  return (
    <div className="h-full min-h-[240px] flex items-center justify-center text-white px-4 text-center">
      Unsupported Content Type : {finalContent.type}
    </div>
  );
};

export default SmartPlayer;
